import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../hooks/use-auth';
import axios from 'axios';
import config from 'config';
import { removeKeyWithValue } from 'utils';
import { PageTitle, CreateNew, ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose } from 'styles/styles';

interface ParentProps {
	data: ParentDataProps[];
	selectedId: number;
	setSelectedId: Dispatch<SetStateAction<number>>;
	setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
	user_id: number
	name: string,
	name_kana: string,
	phone_number: string,
	fax_number: string,
	email: string,
	password: string
	display_id: string,
	[key: string]: string | number;
}

const Parent = ({ data, selectedId, setSelectedId, setIsParentDataInsert }: ParentProps) => {
	const auth = useAuth();
	const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
	//modal
	const [modalTitle, setModalTitle] = React.useState('');
	const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
	const { reset, register, handleSubmit, watch, formState: { errors } } = useForm<ParentDataProps>();
	const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
		try {
			setIsSubmitDisable(true);
			if (!selectedId) {
				const res: any = await auth.createUser(submitData.email, submitData.password, submitData.name, submitData.display_id);
				/* error処理 */
				if (!res.success) {
					if (res.message.code.includes("ERR_BAD_REQUEST")) {
						window.alert(res.message.response.data.error);
					} else {
						window.alert(res.message);
					}
					setIsSubmitDisable(false);
					return;
				} else {
					window.alert("登録が完了しました。");
				}
			} else {
				let alertList: any[] = [];
				const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
				requiredFields.forEach((key) => {
					if (submitData[key] === undefined || submitData[key] === '') {
						alertList.push(key)
					}
				});
				if (alertList.length) {
					let text = '';
					parentArray.forEach(item => {
						if (alertList.includes(item.field)) {
							text += `${item.title}を埋めてください。\n`;
						}
					});
					if (text !== '') {
						alert(text);
						throw new Error('必須項目が未入力です');
					}
				}
				submitData = removeKeyWithValue(submitData, '');
				const branchData = {
					name: submitData.name,
					name_kana: submitData.name_kana,
					phone_number: submitData.phone_number,
					fax_number: submitData.fax_number,
					email: submitData.email,
					display_id: submitData.display_id
				}
				setIsSubmitDisable(true);
				await axios.patch(`/v0/account/users`, branchData, {
					headers: auth.authorizationHeader,
					params: { id: selectedId, factory_id: auth.factoryId }
				});
				window.alert("変更が完了しました");
			}
			close();
			setIsParentDataInsert(true);
		} catch (error: any) {
			window.alert(error.response.data.error);
		}
		setIsSubmitDisable(false);
	};
	//modal end

	const [openCreateNew, setOpenCreateNew] = useState(false);

	//arrayの生成
	const parentArray = [{ title: '', field: 'user_id' },
	{ title: 'ユーザーID', field: 'display_id', type: 'alphanumeric', required: true },
	{ title: '氏名', field: 'name', type: 'text', required: true },
	{ title: '氏名（カナ）', field: 'name_kana', type: 'text' },
	{ title: 'メールアドレス', field: 'email', disable: true },
	{ title: '電話番号', field: 'phone_number', type: 'tel' },
	{ title: 'FAX番号', field: 'fax_number', type: 'tel' }]
	const PAGE_TITLE = "ユーザー一覧"
	const columnsArray: any = [];
	for (const element of parentArray) {
		if (element.title) {
			columnsArray.push({
				title: element.title,
				field: element.field,
				cellStyle: {
					minWidth: 150,
					maxWidth: 150,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}
			})
		}
	}
	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});

	const createNewArray = [
		{ title: '名前', field: 'name', type: 'text', required: true },
		{ title: 'ユーザーID', field: 'display_id', type: 'alphanumeric', required: true },
		{ title: 'メール', field: 'email', type: 'email', required: true },
		{ title: 'パスワード', field: 'password', type: 'password', required: true }
	]

	const createNewListItems = createNewArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});
	//カラムなど生成ここまで

	const defaultMaterialTheme = createTheme();
	const [pageSize, setPageSize] = React.useState(5);

	//IDから既存の値を呼び出し
	async function setModalValue(user_id: number) {
		if (!user_id) {
			setModalTitle("新規作成");
			setOpenCreateNew(true)
			reset({});
		} else {
			//データの取得axios
			setSelectedId(user_id);
			const result: any = await axios.get(`/v0/account/users`, {
				headers: auth.authorizationHeader,
				params: { id: user_id, factory_id: auth.factoryId }
			});
			setOpenCreateNew(false)
			reset(result.data[0]);
			setModalTitle("編集")
		}
	}

	const createNew = async () => {
		setSelectedId(0);
		await setModalValue(0);
		open();
	}

	return (
		<>
			<CreateNew onClick={createNew}>新規作成</CreateNew>
			<ThemeProvider theme={defaultMaterialTheme}>
				<MaterialTable
					title={PAGE_TITLE}
					columns={columnsArray}
					data={data}
					actions={[
						{
							icon: 'edit',
							tooltip: '編集する',
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								try {
									await setModalValue(rowData.user_id);
									open();
								} catch (error) {
									console.log(error)
								}
							}
						}
					]}
					options={{
						actionsColumnIndex: -1,
						headerStyle: { whiteSpace: 'nowrap' },
						rowStyle: { overflowWrap: 'break-word' }
					}}
					onChangeRowsPerPage={(pageSize) => {
						setPageSize(pageSize);
					}}
					onRowClick={(event: any, rowData: any) => {
						event.preventDefault();
					}}
				/>
			</ThemeProvider>

			<Modal>
				<ModalStyle>
					<ModalTitle>{modalTitle}</ModalTitle>
					<ModalForm onSubmit={handleSubmit(onSubmit)}>
						{openCreateNew ? createNewListItems : listItems}
						{isSubmitDisable ? (
							<LoadingContainer>
								<CircularProgress size={20} />
							</LoadingContainer>
						) : (
							<ModalSubmit type="submit" disabled={isSubmitDisable} />
						)}
					</ModalForm>
					<ModalClose onClick={close}>CLOSE</ModalClose>
				</ModalStyle>
			</Modal>
		</>
	)
}

export default function UsersInfo() {
	const auth = useAuth();
	const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
	const [parentData, setParentData] = useState<ParentDataProps[]>([]);
	const [selectedId, setSelectedId] = React.useState(0);

	useEffect(() => {
		try {
			axios.get(`/v0/account/users`, {
				headers: auth.authorizationHeader,
				params: { factory_id: auth.factoryId }
			}).then((res: any) => {
				if (res.data.length) {
					setParentData(res.data);
				} else {
					setParentData([]);
				}
				setIsParentDataInsert(false)
			})
		} catch (err) {
			console.log(err)
		}
	}, [auth, isParentDataInsert]);

	return (
		<>
			<PageTitle>ユーザー一覧</PageTitle>
			<Parent data={parentData} selectedId={selectedId} setSelectedId={setSelectedId} setIsParentDataInsert={setIsParentDataInsert} />
		</>
	)
}